var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search",
      class: [
        { "are-search-results-visible": _vm.searchResultsVisible },
        { "are-search-suggestions-visible": _vm.searchSuggestionsVisible },
      ],
    },
    [
      _c(
        "transition",
        { attrs: { name: "slide" } },
        [
          _vm.searchSuggestionsVisible
            ? _c("search-suggestions", {
                attrs: {
                  filterOptions: _vm.filterOptions,
                  suggestions: _vm.searchSuggestions,
                  searchQuery: _vm.searchQuery,
                  results: _vm.searchResults,
                  searchOption: _vm.searchOption,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide" } },
        [
          _vm.searchResultsVisible
            ? _c("search-results", {
                attrs: {
                  indices: _vm.indices,
                  filterOptions: _vm.filterOptions,
                  results: _vm.searchResults,
                  searchQuery: _vm.searchQuery,
                  productSuggestions: _vm.productSuggestions,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }